import React from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { useAuthContext } from '../hooks/AuthContext';
import { useAdminAccess } from '../hooks/AdminAccessContext';
import './AdminLayout.css';

const navItems = [
  { to: '/admin', label: 'Dashboard', end: true },
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/sessions', label: 'Sessions' },
  { to: '/admin/content', label: 'Content' },
  { to: '/admin/creator-studio', label: 'Creator Studio' },
  { to: '/admin/payments', label: 'Payments & Credits' },
  { to: '/admin/analytics', label: 'Analytics' },
  { to: '/admin/ops', label: 'Ops Status' },
  { to: '/admin/settings', label: 'Settings' },
  { to: '/admin/audit-log', label: 'Audit Log' },
];

const AdminLayout = () => {
  const { signOut } = useAuthContext();
  const { adminAccess } = useAdminAccess();

  return (
    <div className="cq-admin-shell">
      <aside className="cq-admin-sidebar">
        <div className="cq-admin-brand">
          <p className="cq-admin-brand__eyebrow">Operations</p>
          <h1 className="cq-admin-brand__title">Cringe Quest Admin</h1>
          <p className="cq-admin-brand__meta">{adminAccess?.email || 'Admin access verified'}</p>
        </div>

        <nav className="cq-admin-nav" aria-label="Admin navigation">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `cq-admin-nav__item${isActive ? ' is-active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="cq-admin-sidebar__footer">
          <Link className="cq-admin-sidebar__link" to="/chat">Back to Game</Link>
          <button type="button" className="cq-admin-sidebar__button" onClick={signOut}>Sign Out</button>
        </div>
      </aside>

      <main className="cq-admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
